/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getSignalsListCached } from '../../../../../stores/signals-main/signals/getters';
import { useHistory } from 'react-router-dom';
import { saveSignalsListLocation } from '../helpers/save-and-send-location';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
  },
}));

const CellAlgoNo = ({ row = {} }) => {
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;
  const history = useHistory();

  const linkedAlgoCount = useSelector((state) => {
    const { linkedAlgoCount = 0 } =
      getSignalsListCached(state).find((d) => d._id === _id) || {};

    return linkedAlgoCount;
  });

  const handleRedirectToEdit = () => {
    saveSignalsListLocation();

    history.push(`/signals/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToEdit}>
      {linkedAlgoCount}
    </div>
  );
};

export default CellAlgoNo;
